<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrStratejikAmac from "@/models/StrStratejikAmac";
import AddEdit from "./AddEdit.vue";

export default {
  mixins: [Api, Sabit, StrStratejikAmac],
  page: {
    title: "Stratejik Amaçlar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("StrStratejikAmac.Title"),
      items: [
        {
          text: this.$t("StrStratejikAmac.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrStratejikAmac.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrStratejikAmac.Title"),
          active: true,
        },
      ],
      islem: "",
      TableData: [],
      StrPerfDonem: [],
      DataUpdate: "",
      AddEdit: "",
      FormTitle: "",
      FilitrelemePenceresi: false,
      Filter: {
        Aciklama: "",
        DonemId:"",
      },
      siralama:"&Asc=Aciklama",

      DefaultPage: 1,

      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },

  methods: {
    Get() {
      let Filter = "";

      if (this.Filter.Aciklama!="" && this.Filter.Aciklama!=null) {
        Filter = Filter + "&Aciklama=" + this.Filter.Aciklama;
      }

      if (this.Filter.DonemId!="" && this.Filter.DonemId!=null) {
        Filter = Filter + "&DonemId=" + this.Filter.DonemId;
      }

      if(this.siralama!=null && this.siralama!=""){
        Filter=Filter+this.siralama;
      }

      this.ActionsFilterGet({ Service: "StrStratejikAmac", Page: this.Page, Filter: Filter }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  created(){

        let Page= {
      PageNumber: "1",
      PageSize: "9999"
    }
          this.StrPerfDonem=[];


         
      let sorgu = "&Tip=1561";
      let Tip=[];
        
        this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {

            for(var i=0; i<res.Data.length; i++)
            {   
                if(res.Data[i].Kod==1 || res.Data[i].Kod==2 || res.Data[i].Kod==5 ) { 
                    Tip.push(res.Data[i].Id);       
                }            
            }

            let altsorgu="&UstIdDoluMu=false&Approval=true";

            let tipler="";

            for (var s=0; s<Tip.length; s++){

                tipler=tipler+"&TipId="+Tip[s];

            }

            altsorgu=altsorgu+tipler;

         

            this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
            for (var i = 0; i < res.Data.length; i++) {
        
               
              this.StrPerfDonem.push({ Id: res.Data[i].Id, Value: res.Data[i].Aciklama });
              
            }
          });
     
        });



  }


};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />


      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input @input="Filter.Aciklama.length >= 3 || Filter.Aciklama.length == 0 ? Get() : ''" 
                    v-model="Filter.Aciklama" type="text" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrStratejikAmac.Page.Filtreleme") }}</button>

                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrStratejikAmac @click="(DataUpdate = StrStratejikAmacData), (AddEdit = 'Add')"><i class="mdi mdi-plus me-1"></i> {{ this.$t("StrStratejikAmac.Page.YeniKayitEkle") }}</button>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th scope="col">{{ this.$t("StrStratejikAmac.Table.Aciklama") }}
                    
                    <i style="margin-left:10px" v-if="siralama!='&Asc=Aciklama'" @click="siralama='&Asc=Aciklama', Get()" class="bx bx-sort-a-z fa-xl"></i>
                    <i style="margin-left:10px" v-if="siralama=='&Asc=Aciklama'" @click="siralama='&Desc=Aciklama', Get()" class="bx bx-sort-z-a  fa-xl"></i>
                   
                    </th>
                    <th scope="col">{{ this.$t("StrStratejikAmac.Table.DonemId") }}</th>
                    <th style="width: 80px; text-align: center; vertical-align: middle;">{{ this.$t("StrStratejikAmac.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="Data in TableData" :key="Data.Id">
                    <td>{{ Data.Aciklama }}</td>
                    <td>{{ Data.Donemadi.join(' , ') }}</td>
                    <td style="width: 80px; text-align: center; vertical-align: middle;">
                      <b-button-group>
                        <b-button variant="primary" v-b-modal.StrStratejikAmac @click="(DataUpdate = Data), (AddEdit = 'Edit')"><i class="fas fa-pencil-alt"></i></b-button>
                        <b-button variant="danger" @click="Delete('StrStratejikAmac', Data.Id)"><i class="fas fa-trash-alt"></i></b-button>
                      </b-button-group>
                      
                    </td>
                  </tr>
                </tbody>
              </table>

              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"></b-pagination>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrStratejikAmac.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrStratejikAmac.Filtreleme.Content") }}
            <hr />

              <div class="mb-3 ">
              <select style="width:400px" v-model="Filter.DonemId" class="form-select" type="text">
                <option value="">{{ $t("StrPerfTablo.Filtreleme.DonemId") }}</option>
                <option v-for="DonemVerileri in StrPerfDonem" :key="DonemVerileri.Id" :value="DonemVerileri.Id">
                  {{ DonemVerileri.Value }}
                </option>
              </select>
            </div>

            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrStratejikAmac.Filtreleme.Aciklama") }}</label>
              <b-form-input v-model="Filter.Aciklama" for="text" value=""></b-form-input>
            </div>

            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrStratejikAmac.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
